import { instance } from '@/utils/http.js'
import { instances as rpcinstance } from '@/utils/httpAaser.js'

// 获取聊天列表`
export const getChatList = function (params) {
  return rpcinstance({
    url: '/api/rpc/ai/chat/list',
    method: 'get',
    params
  })
}

//获取聊天信息
export const getChatInfo = function (params) {
  return rpcinstance({
    url: '/api/rpc/ai/chat/info',
    method: 'get',
    params
  })
}


// 发送问题
export const sendQuestion = function (data) {
  return rpcinstance({
    url: '/api/rpc/ai/chat/send',
    method: 'post',
    data,
    
  })
}

//重答
export const resend = function (data) {
  return rpcinstance({
    url: '/api/rpc/ai/chat/resend',
    method: 'post',
    data
  })
}
export const getModelList = function (params) {
  return rpcinstance({
    url: '/api/rpc/ai/model/list',
    method: 'get',
    params
  })
}
export const getTypeList = function (params) {
  return rpcinstance({
    url: '/api/rpc/ai/model/list',
    method: 'get',
    params
  })
}

export const delChat = function (data) {
  return rpcinstance({
    url: '/api/rpc/ai/chat/list',
    method: 'delete',
    data
  })
}

//上传图片

export const uploadImg = function (data) {
  return rpcinstance({
    url: '/api/rpc/ai/chat/upload/img',
    method: 'POST',
    data
  })
}
export const uploadFile = function (data) {
  return rpcinstance({
    url: '/api/rpc/ai/chat/upload/file',
    method: 'POST',
    data
  })
}
 